import { TableHeading } from "../../../../components/common/table/TableDesign";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};
export const SOURCE_REVIEW_FIELDS = [
  {
    id: "driver_wage",
    label: "Driver Wage",
    placeHolder: "Enter Driver Wage",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "porter_wage",
    label: "Porter wage",
    placeHolder: "Enter Porter wage",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "packer_wage",
    label: "Packer wage",
    placeHolder: "Enter Packer wage",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  // {
  //   id: "contents_value",
  //   label: "Contents Value",
  //   placeHolder: "Enter Contents Value",
  //   type: "text",
  //   // md: 6.5,
  //   // isRequired: true,
  //   inputProps: {
  //     maxLength: 4,
  //   },
  //   patternAllowed: patternConstant?.NUMERIC,
  // },
];

export const EMAIL_AUTOMATION_FIELDS = [
  {
    id: "manual_lead_email",
    label: "Driver Wage",
    placeHolder: "Enter Driver Wage",
    type: "toggle",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "import_lead_email",
    label: "Porter wage",
    placeHolder: "Enter Porter wage",
    type: "toggle",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
];

export const GENERAL_LEAD_NOTIFICATION_FIELDS = [
  {
    id: "message",
    label: "Message",
    placeHolder: "Enter Message",
    type: "text",
    // md: 6.5,
    isRequired: true,
    inputProps: {
      maxLength: 250, // Allow values like 9999.99
    },
    // patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "color",
    label: "Color",
    placeHolder: "Enter Color",
    type: "text",
    // md: 6.5,
    isRequired: true,
    inputProps: {
      maxLength: 10, // Allow values like 9999.99
    },
    // patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  
  {
    id: "forward_days",
    label: "Days from today's date",
    placeHolder: "Enter Days from today's date",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 3, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "old_days",
    label: "Days from today's date",
    placeHolder: "Enter Days from today's date",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 3, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
];

export const LEAD_NOTIFICATION_TABLE_HEADER: TableHeading[] = [
  { label: "ID", align: "left" },
  { label: "Message ( ## is the count of leads that match )", align: "left" },
  { label: "Color", align: "left" },
  { label: "Source ", align: "left" },
  { label: "Action", align: "center" },
];
